
import { When } from "react-if";

import { Modal } from "../../../common/Atoms/Modal";
import { Paragraph } from "../../../common/Atoms/Typography/Paragraph";
import { Button } from "../../../common/Atoms/Button";
import { Divider } from "../../../common/Atoms/Divider";

interface UnsavedChangesModalProps {
  onCancel: () => void;
  onConfirm: () => void;
  onSaveAndExit?: () => void;
  show: boolean;
  title: string | React.ReactNode;
  message: string;
}

export function UnsavedChangesModal({ onCancel, onConfirm, show, title, message, onSaveAndExit }: UnsavedChangesModalProps) {
  function onClose() {
    // This is the top X, treat as cancel
    onCancel();
  }

  return (
    <Modal
      title={ title }
      open={ show }
      setOpen={ onClose }
    >

      <div className={ `flex flex-col items-center mt-6` }>
        <Paragraph variant={ `error` }>
          { message }
        </Paragraph>

        <Divider weight={ `light` } />

        <div>
          <Button
            color={ `gray` }
            className={ `mr-4` }
            onClick={ onCancel }
          >
            { `Back` }
          </Button>
          <Button
            className={ `mr-4` }
            color={ `red` }
            onClick={ onConfirm }
          >
            { `Discard Changes` }
          </Button>
          <When condition={ !!onSaveAndExit }>
            <Button
              color={ `paidniceGreen` }
              onClick={ onSaveAndExit }
            >
              { `Save & Exit` }
            </Button>
          </When>
        </div>
      </div>

    </Modal>
  );
}

